import { useContextState } from "../../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        list: {
            width: '100%',
            height: '454px',
        },
        empty: {
            width: '100%',
            fontSize: '20px',
            fontWeight: '400',
            color: colors.color13,
            textAlign: 'center',
            padding: '20px 0',
            marginTop: 3
        },
        divider: {
            width: "95%",
            margin: "0 auto",
            borderBottomWidth: "3px",
        },
        title: {
            height: '40px',
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
        },
        userContainer: {
            padding: '4px 8px',
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            color: colors.color13,
            marginBottom: 2,
            '& .MuiSvgIcon-root': {
                fontSize: '28px'
            },
            '& .closeIcon': {
                '& .MuiSvgIcon-root': {
                    fontSize: '24px'
                },
            }
        },
        userBox: {
            border: `1px solid ${colors.color32}`,
            borderRadius: 1
        },
        buttonClose: {
            '&.MuiIconButton-root': {
                padding: '0px'
            }
        },
        containerText: {
            flex: '1 1 200px',
            minWidth: '200px',
        },
        containerTitle: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        button: {
            height: '40px',
            background: '#ec6666',
            '& button': { color: 'white' },
            '&:hover': {
                backgroundColor: '#ec666699',
            },
        }
    }
}

export { useStyles }
